var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M40.646,18.38H30.119A11.75,11.75,0,0,0,18.382,30.116V40.644A11.75,11.75,0,0,0,30.119,52.38H40.646A11.749,11.749,0,0,0,52.382,40.644V30.116A11.749,11.749,0,0,0,40.646,18.38Z",
    transform: "translate(-18.382 -18.38)",
    fill: "#d90028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M18.424,40.436v-10.4c0-6.409,6.2-11.611,13.847-11.611h4.806c-3.765.634-13.933,3.085-15.473,10.929l-.071,12.794s.371,5.214,3.123,7.988C20.906,48.053,18.424,44.489,18.424,40.436Z",
    transform: "translate(-18.42 -18.418)",
    fill: "#fff",
    opacity: 0.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M152.361,30.16V40.677c0,6.479-4.977,11.738-11.109,11.738H131.3a10.6,10.6,0,0,1-3.718-.677l10.033-.907c10.365-1.511,10.766-8.909,10.766-8.909l-.046-12.85s-.217-7.555-8.832-10.65h1.751C147.384,18.422,152.361,23.681,152.361,30.16Z",
    transform: "translate(-118.364 -18.418)",
    fill: "#160204",
    opacity: 0.13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M264.364,337.081l1.034-.718.984.714a.311.311,0,0,0,.48-.345l-.366-1.171,1-.764a.311.311,0,0,0-.189-.558h-1.212l-.408-1.122a.311.311,0,0,0-.3-.2.307.307,0,0,0-.291.211l-.377,1.115H263.5a.311.311,0,0,0-.19.557l.965.746-.381,1.188a.311.311,0,0,0,.474.351Z",
    transform: "translate(-245.685 -310.234)",
    fill: "#ffda44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M265.393,129.037a.309.309,0,0,1,.292.2l.408,1.122h1.212a.311.311,0,0,1,.189.558l-1,.764.366,1.171a.311.311,0,0,1-.48.345l-.984-.715-1.034.718A.326.326,0,0,1,264,133.2a.311.311,0,0,1-.111-.345l.381-1.188-.965-.746a.311.311,0,0,1,.19-.557h1.224l.377-1.115A.307.307,0,0,1,265.393,129.037Z",
    transform: "translate(-245.686 -121.939)",
    fill: "#ffda44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M322.171,280.2l1.034-.718.984.714a.311.311,0,0,0,.48-.345l-.366-1.171,1-.764a.311.311,0,0,0-.189-.558H323.9l-.408-1.122a.313.313,0,0,0-.3-.2.321.321,0,0,0-.291.212l-.377,1.115H321.3a.311.311,0,0,0-.19.557l.965.746-.381,1.188a.311.311,0,0,0,.111.345A.3.3,0,0,0,322.171,280.2Z",
    transform: "translate(-299.078 -257.698)",
    fill: "#ffda44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M322.171,190.08l1.034-.718.984.714a.311.311,0,0,0,.48-.345l-.366-1.171,1-.764a.311.311,0,0,0-.189-.558H323.9l-.408-1.122a.311.311,0,0,0-.587.007l-.377,1.115H321.3a.311.311,0,0,0-.19.557l.965.746-.381,1.188a.311.311,0,0,0,.111.345A.316.316,0,0,0,322.171,190.08Z",
    transform: "translate(-299.078 -174.467)",
    fill: "#ffda44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M116.065,192.422l3.56-2.474,3.4,2.467a.626.626,0,0,0,.965-.693l-1.261-4.036,3.438-2.63a.626.626,0,0,0-.38-1.123H121.6l-1.409-3.875a.626.626,0,0,0-1.181.014l-1.3,3.861h-4.227a.626.626,0,0,0-.383,1.121l3.327,2.572-1.313,4.091a.626.626,0,0,0,.224.694A.64.64,0,0,0,116.065,192.422Z",
    transform: "translate(-107.08 -169.09)",
    fill: "#ffda44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.995e89a416903671f36df06b8464a31c.svg";
export { ForwardRef as ReactComponent };